import script from "./multiCall.vue?vue&type=script&setup=true&lang=js"
export * from "./multiCall.vue?vue&type=script&setup=true&lang=js"

import "./multiCall.vue?vue&type=style&index=0&id=5913a7df&lang=scss&scoped=true"

import exportComponent from "D:\\works\\淘游虎\\yududs-im\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5913a7df"]])

export default __exports__